import { useEffect, useState } from 'react';

const usePropertyGroupProperty = ({
  property,
  selectedDatabase,
  bearerToken,
  refreshBearerToken
}) => {
  const [loading, setLoading] = useState(false);
  const [propertyGroups, setPropertyGroups] = useState([]);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_PROPERTIES_API_URL}api/properties/${property.id}/property-groups?with[]=users.propertyRole.propertyPermissions`,
      {
        headers: {
          Accept: 'application/json',
          SeasonalDatabase: selectedDatabase,
          Authorization: `Bearer ${bearerToken}`
        }
      }
    )
      .then((res) => {
        if (res.ok) return res.json();
        else if (res.status === 401) refreshBearerToken();
        else throw Error(res.statusText);
      })
      .then((data) => {
        if (mounted) setPropertyGroups(data);
      })
      .catch((err) => {
        if (process.env.NODE_ENV === 'development') console.error(err);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [selectedDatabase, bearerToken, property]);

  return { loading, propertyGroups };
};

export default usePropertyGroupProperty;
